import React, { useState } from "react";

const StarRating = ({ onRate }) => {
    const [hoveredStars, setHoveredStars] = useState(0); // Tracks stars currently hovered
    const [selectedStars, setSelectedStars] = useState(0); // Tracks the locked rating

    const handleMouseEnter = (rating) => {
        setHoveredStars(rating);
    };

    const handleMouseLeave = () => {
        setHoveredStars(0); // Reset hover effect
    };

    const handleClick = (rating) => {
        setSelectedStars(rating); // Lock the rating
        if (onRate) onRate(rating); // Trigger callback if provided
    };

    return (
        <div className="star-rating">
            {[1, 2, 3, 4, 5].map((star) => (
                <i
                    key={star}
                    className={`fa-solid fa-star ${(hoveredStars || selectedStars) >= star ? "highlighted" : ""
                        }`}
                    onMouseEnter={() => handleMouseEnter(star)}
                    onMouseLeave={handleMouseLeave}
                    onClick={() => handleClick(star)}
                ></i>
            ))}
        </div>
    );
};

export default StarRating;